function grainPickerClicked(colorObj, width, height) {

    if (selectedRegion) {

        this.Viewer.setMaterial(selectedRegion._Name, "GRAIN", colorObj);


        //this.Viewer.setColorByID(selectedRegion._Name,e.hex);
        ///	Viewer.setPatternByID(selectedRegion._Name,
        //colorObj["image"], width, height);


        // $(".large-icon-swatch").css("backgroundColor",e.hex );


        createList(this.Viewer.getRegionObjectArray());
    }
}


function createGrainPanel(grains) {


    /*
     $('#color_swatch_container').masonry({
     itemSelector: '.swatch-item',

     });
     */

    grains = grains["options"];


    for (var i = 0; i < grains.length; i++) {

        const imgElement = document.createElement('img')

        imgElement.src = grains[i].image

        document.getElementById('grainPanel').appendChild(imgElement)

        let grain  = grains[i]

        imgElement.addEventListener('click', event => {
            selectedRegion = this.Viewer.getRegionObjectByID("Top Insert")
            grainPickerClicked(grain, imgElement.style.width, imgElement.style.height)
        })

    }


}